import { EventType } from '@angular/router';
import { Action } from '@ngrx/store';
import { RouterNavigationEvent } from '@floori-web/models';
import { routerActions } from '@floori-web/store';

export const routerActionsMap: ReadonlyMap<
    EventType,
    (event: RouterNavigationEvent) => Action<string>
> = new Map<EventType, (event: RouterNavigationEvent) => Action<string>>([
    [
        EventType.NavigationStart,
        (event: RouterNavigationEvent): Action<string> => routerActions.routeNavigationStart(event),
    ],
    [
        EventType.NavigationEnd,
        (event: RouterNavigationEvent): Action<string> => routerActions.routeNavigationEnd(event),
    ],
    [
        EventType.NavigationError,
        (event: RouterNavigationEvent): Action<string> => routerActions.routeNavigationError(event),
    ],
    [
        EventType.NavigationCancel,
        (event: RouterNavigationEvent): Action<string> => routerActions.routeNavigationError(event),
    ],
]);
